import { Component } from 'react';

export class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof window !== 'undefined' && window.console) {
      console.error('ErrorBoundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            textAlign: 'center',
            fontFamily: 'Roboto, sans-serif',
          }}
          role="alert"
        >
          <h1 style={{ fontSize: '1.5rem', marginBottom: 12, color: '#1a1a1a' }}>
            Bir şeyler yanlış gitti
          </h1>
          <p style={{ color: '#555', marginBottom: 24, maxWidth: 400 }}>
            Sayfa yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin veya ana sayfaya dönün.
          </p>
          <a
            href="/"
            style={{
              padding: '12px 24px',
              background: '#1a237e',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: 8,
              fontWeight: 600,
            }}
          >
            Ana sayfaya dön
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}
